import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthFacade } from '../facades/auth.facade';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return toObservable(authFacade.isLoading).pipe(
    filter(isLoading => !isLoading),
    map(() => {
      if (!authFacade.isAuthenticated()) {
        return router.createUrlTree(['/auth/login']);
      }
      if (authFacade.isIncompleteStudent()) {
        return router.createUrlTree(['/onboarding']);
      }
      return true;
    })
  );
};
